// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__7kmBh","logo":"Navbar_logo__pKoS3","menus":"Navbar_menus__QOVhR","hamburger":"Navbar_hamburger__xW68J"};